import styled from "styled-components"

export const Wrapper = styled.div`
  &:hover {
    cursor: pointer;
  }

  .faq-item {
    border-top: 1px solid var(--main-blue);
    border-right: 1px solid var(--main-blue);
    border-left: 1px solid var(--main-blue);

    &:last-child {
      border-bottom: 1px solid var(--main-blue);
    }
  }

  .faq-title {
    border: none;
    background: none;
    padding: 0;
    outline: none;
    width: 100%;
    text-align: left;
    cursor: pointer;

    font-family: "Catamaran", sans-serif;
    font-size: 24px;
    font-weight: bold;
    padding: 24px;
    padding-right: 48px;
    position: relative;

    &::after {
      content: "";
      display: block;
      width: 12px;
      height: 12px;
      margin: 9px -24px 3px 0;
      border-left: 2px solid #211e26;
      border-bottom: 2px solid #211e26;
      float: right;
      transform: rotate(-45deg);
      transition: transform 0.3s ease-in-out;
    }

    &.active {
      &::after {
        transform: rotate(135deg);
      }
    }
  }

  .faq-content {
    color: #555555;
    font-family: "Avenir Next", sans-serif;
    font-size: 18px;
    padding: 0 72px 24px 24px;
  }
`
